// noinspection JSUnresolvedFunction

import {LinkLoaderComponent} from "./link-loader/LinkLoaderComponent";

import MatchHeight from '@tannerhodges/match-height';
import {Wizard} from "./wizard/Wizard";

export class AllInBox {
    static init() {
        LinkLoaderComponent.init();

        $('[data-toggle="tooltip"]').tooltip();

        let elems = Array.prototype.slice.call(document.querySelectorAll('.js-switch:not([data-switchery="true"])'));
        elems.forEach((element) => {
            new Switchery(element, {});
        });

        const btnSearch = document.getElementById('btn-contact-search');
        if(btnSearch){
            btnSearch.addEventListener('click', () => {
                const contactSearch = document.getElementById('contact-search');
                contactSearch.value = '';
            });
        }
        MatchHeight.update();
    }
}